export default __webpack_public_path__ + "static/media/languages_icon.204f5053.svg";